import Vue from "vue";
import Vuex from "vuex";
import api from "../service/api";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  state: {
    loginUser: null,
    // 判断公司是否认证，没认证不能用
    authorizedInfo: null,
    inQlw: false,
    companyList: {
      isQlwVersion: null,
      name: "",
    },
  },
  mutations: {
    setLoginUser(state, payload) {
      state.loginUser = payload;
    },
    setAuthorizedInfo(state, payload) {
      state.authorizedInfo = payload;
    },
    setInQlw(state) {
      state.inQlw = true;
    },
    setQlw(state, payload) {
      state.companyList.isQlwVersion = payload;
    },
    setCompanyList(state, payload) {
      state.companyList = payload;
    },
  },
  actions: {
    async getSerialNumber() {
      let result = await api.get("/api/SerialNumber");
      return result.data;
    },
    async getLoginUser({ commit }) {
      let result = await api.get("/api/account/LoginUser");
      commit("setLoginUser", result.data);
    },
    // 获取认证信息
    async getAuthorizedInfo({ commit }) {
      let result = await api.get("/api/Enterprise/GetEnterpriseIsAuth");
      commit("setAuthorizedInfo", result.data);
    },
    async getCompanyList({ commit }) {
      let result = await api.get("/api/Enterprise/Simple");
      commit("setCompanyList", result.data);
      return result.data;
    },
  },
});
